<template>
  <v-card>
    <router-view :key="$route.fullPath"></router-view>
  </v-card>
</template>
<script>
export default {
  watch: {
    '$route.params' () {
      if (!this.$route.name) this.$router.push('/orders/type/offer')
    }
  },
  mounted () {
    if (!this.$route.name) this.$router.push('/orders/type/offer')
  }
}
</script>
